<div class="header-fixed w-100">
    <!-- <div class="news-scroll">
        <div class="newsbtn">
            <mat-icon> list_alt</mat-icon>
            <span class="ms-1">News</span>
        </div>
        <ul class="mb-0 p-0">
            <li>We are India’s market leader in commercial vehicles and amongst the top three in the passenger vehicles
                market. </li>
        </ul>
    </div> -->

    <div class="header-new" id="scroll-uptoheader">
        <div class="logoContainer">
            <!-- <a class="me-3" type="button" data-bs-toggle="offcanvas" data-bs-target="#NavbarOffcanvas"
                aria-controls="NavbarOffcanvas">
                <mat-icon>sort</mat-icon>
               
            </a> -->
            <div class="svg-middle-align cursor-pointer">
                <!-- <img src="../../../../assets/images/logo.svg" class="LGI_Logo" alt="Liberty Partner First Home"
          title="Liberty Partner First Home" /> -->
                <img src="../../../../assets/images/liberty-logo.webp" class="LGI_Logo" alt="Liberty General Insurance"
                    title="Liberty General Insurance" width="164" height="56" />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid px-lg-4 formConatiner">
    <mat-accordion>
        <mat-expansion-panel [(expanded)]="policyDetailsPanelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Policy Details
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mb-2">
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Policy No</label>
                    <label class="labelValue">{{user?.policyNumber}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Insured Name</label>
                    <label class="labelValue">{{user?.customerName}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Insured Address</label>
                    <label class="labelValue">{{user?.customerAddress1}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Policy Start Date</label>
                    <label class="labelValue">{{user?.formattedOdStartTime}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Policy End Date</label>
                    <label class="labelValue">{{user?.formattedOdEndTime}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Mobile No.</label>
                    <label class="labelValue">{{user?.customerMobileNumber}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Email Id</label>
                    <label class="labelValue">{{user?.customerEmail}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Registration Number</label>
                    <label class="labelValue">{{user?.vehicleRegistrationNo}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Engine Number</label>
                    <label class="labelValue">{{user?.engineNo}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Chassis Number</label>
                    <label class="labelValue">{{user?.chassisNo}}</label>
                </div>

                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Endorsement Date</label>
                    <label class="labelValue"></label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Endorsement Number</label>
                    <label class="labelValue"></label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Endorsement Effective Date</label>
                    <label class="labelValue"></label>
                </div>

                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Issuing Office Name</label>
                    <label class="labelValue">{{user?.insuranceCompanyName}}</label>
                </div>

                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Issuing Office Address</label>
                    <label class="labelValue">{{user?.officeAddress}}</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Endorsement Premium</label>
                    <label class="labelValue"></label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">GSTIN No Of Insured</label>
                    <label class="labelValue"></label>
                </div>
                <div class="col-md-6 col-lg-3">
                </div>
            </div>



        </mat-expansion-panel></mat-accordion>

    <mat-accordion>
        <mat-expansion-panel [(expanded)]="cancellationDetailsPanelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Cancellation Details
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mb-2">
                <div class="col-md-6 col-lg-3">
                    <label class="labelName d-block">Cancellation Reason</label>
                </div>
                <div class="col-md-6 col-lg-3">
                    <!-- <label class="labelName d-block">Insured Name</label> -->
                    <label class="labelValue">{{user?.reasonOfCancellation}}</label>
                </div>

                <div class="col-md-6 col-lg-3">
                </div>
            </div>



        </mat-expansion-panel>
    </mat-accordion>


    <mat-accordion>

        <mat-expansion-panel [(expanded)]="documentDetailsPanelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Document Details
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row mt-2">
                <div class="col-md-12 table-responsive">
                    <table mat-table [dataSource]="dataSource" class="custom-table border mt-2 w-100">

                        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

                        <!-- Position Column -->
                        <ng-container matColumnDef="fileName">
                            <th mat-header-cell *matHeaderCellDef> File Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.fileName}} </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="docName">
                            <th mat-header-cell *matHeaderCellDef> Category Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.documentCategoryName}} </td>
                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="link">
                            <th mat-header-cell *matHeaderCellDef> Download Link </th>
                            <td mat-cell *matCellDef="let element">
                                <a target="_blank" style="color: blue;" class="resend-link" (click)="downloadEFile(element?.fileName, element?.documentCategoryName)">Download</a>
                            </td>
                        </ng-container>
                        <!-- Weight Column -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef> Delete </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button color="primary" disabled>Delete</button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="DocDescColums"></tr>
                        <tr mat-row *matRowDef="let row; columns: DocDescColums;"></tr>
                    </table>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>


    <mat-accordion>
        <mat-expansion-panel [(expanded)]="consentModePanelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Consent Mode : OTP
                </mat-panel-title>
            </mat-expansion-panel-header>

            <form [formGroup]="otpForm" (ngSubmit)="submitCancellation()">
                <div class="row mb-2">
                    <div class="col-md-3">
                        <mat-form-field appearance="outline" class="w-100 chassisField">
                            <mat-label>Verify OTP</mat-label>
                            <input matInput formControlName="otp" inputmode="numeric" maxlength="6" pattern="[0-9]*"
                                placeholder="123456" (keypress)="allowOnlyNumeric($event)" (paste)="onCopyPasteNumber($event)" />
                        </mat-form-field>
                        <mat-error *ngIf="otpForm.get('otp')?.touched && otpForm.get('otp')?.invalid">OTP must be of 6 digit</mat-error>
                        <button mat-raised-button color="primary" type="submit" [disabled] ="otpForm.get('otp')?.invalid">
                            Submit
                        </button>
                    </div>


                    <div class="col-md-12 col-lg-12">

                    </div>
                </div>
            </form>
        </mat-expansion-panel>

    </mat-accordion>



</div>


<!-- 
<div class="container-fluid px-lg-4">
    <div class="view-status-wrap">
        <div class="formConatiner">

        </div>
    </div>
</div> -->